module.exports = __webpack_public_path__ + "assets/img/banner4.4bf37eea.png";